import React from 'react';
import isNil from 'lodash-es/isNil';
import { gql } from '@yi/core';

import { graphql, useStaticQuery } from 'gatsby';
import { MeditationCarousel } from '~/src/components/carousels/MeditationCarousel';

import { sortCardsByIds } from '../sortCardsByIds';

interface Props {
  children: (data: React.ComponentProps<typeof MeditationCarousel>['items']) => React.ReactNode;
}
const list = [
  // Deep Rest and Relaxation	Hilary Jackendoff
  '4lpy9MWS8JzAUoRgZ5Zx47',
  // Invite Sleep	Jeremy Wolf
  '4iV6hhDEUBnEhPAFG5yev9',
  // Morning Presence	Luke Ketterhagen
  '6EWh2RZsoLgcQJUxhTsp5O',
  // Meditation Using Soham Mantra	Rolf Sovik
  '47792',
  // Mid-Day Recharge and Stress Relief	Hilary Jackendoff
  '1ecoorp1SGZy5rCVBQPJA3',
  // Yoga Nidra 45-Minute Practice	Lynn Matthews
  '91773',
  // Nurture Unconditional Acceptance	Cyndi Lee
  '5086178',
  // A Sound Bath for Better Sleep	Shawn J Moore
  '5735355',
  // Shifting Anxiety	Corina Benner
  '3dk29qgmNU0J5qWu2YPAtm',
  // A Starry Night Bedtime Story	Oneika Mays
  '1KwPp8gJUZvynoEEFcOZ7l',
  // Time Out from Overwhelm	Nico Luce
  '7JbDNPe8s5AD4ZCstblvp7',
  // No Stress Express	Amy Ippoliti
  '2WIwXOFeROWCXjVoE6rFBX',
];

export const MeditaionCarouselDataEN: React.FC<Props> = ({ children }) => {
  const yiData = useStaticQuery<gql.typesSsr.Query_AllMeditaions_LOH_EN>(graphql`
    query Query_AllMeditaions_LOH_EN {
      yi {
        allMeditations(
          filter: {
            ids: [
              "4lpy9MWS8JzAUoRgZ5Zx47"
              "4iV6hhDEUBnEhPAFG5yev9"
              "6EWh2RZsoLgcQJUxhTsp5O"
              "47792"
              "1ecoorp1SGZy5rCVBQPJA3"
              "91773"
              "5086178"
              "5735355"
              "3dk29qgmNU0J5qWu2YPAtm"
              "1KwPp8gJUZvynoEEFcOZ7l"
              "7JbDNPe8s5AD4ZCstblvp7"
              "2WIwXOFeROWCXjVoE6rFBX"
            ]
          }
        ) {
          ...Fragment_MeditationCard
        }
      }
    }
  `);

  const data = yiData?.yi?.allMeditations;
  if (isNil(data)) {
    return null;
  }
  const sortedClassesData = sortCardsByIds(data, list);

  return <>{children(sortedClassesData)}</>;
};
